import { AUTHENTICATION_V2_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { EntityTypes } from '@dtx-company/inter-app/src/redux/slices/modal'

export const MAX_FILE_SIZE = 10000000
export async function uploadProfileImage(props: {
  image: string
  token: string
  entityId?: string
  entityType: EntityTypes
}): Promise<void> {
  const ithacaImageUrl = `${AUTHENTICATION_V2_ENDPOINT}/images`
  const { image, token, entityId, entityType } = props
  try {
    const formData = new FormData()
    const imageBlob = await fetch(image).then(r => r.blob())
    formData.append('file', imageBlob)
    if (entityId) formData.append('entityId', entityId)
    formData.append('entityType', entityType.toString())
    await fetch(ithacaImageUrl, {
      method: 'PUT',
      body: formData,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
  } catch (e) {
    if (e.status === 413) {
      throw Error(`File is too large. Please upload a file less than ${MAX_FILE_SIZE / 1000000}MB.`)
    }
  }
}

export async function deleteProfileImage(props: {
  token: string
  entityId?: string
  entityType: EntityTypes
}): Promise<void> {
  const ithacaImageUrl = `${AUTHENTICATION_V2_ENDPOINT}/images`
  const { token, entityId, entityType } = props

  try {
    await fetch(ithacaImageUrl, {
      method: 'DELETE',
      body: JSON.stringify({
        ...(entityId && { entityId }),
        entityType
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
  } catch (e) {
    if (e.status === 413) {
      throw Error('Error deleting profile picture')
    }
  }
}
